module.exports = __webpack_public_path__ + "static/media/BrightonAction.41edd75f.jpg";